import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';

export function renderDateTimeCell(cell, row, colIndex) {
	let day, time;
	if (cell) {
		let idx = cell.lastIndexOf(' ');
		if (idx > 0) {
			day = cell.substring(0, idx);
			time = cell.substring(idx + 1);
		} else {
			day = cell;
		}
	}
	return (
		<>
			<CellMainText className="secondary">{day}</CellMainText>
			<CellSubText>{time}</CellSubText>
		</>
	);
}
